/* eslint-disable */
import { gql } from 'graphql-tag';
import { v4 as uuidv4 } from 'uuid';
import { store } from '@store/store';
import CategoryManagementEvent from 'src/constants/events';
import { NotificationMessageProps } from 'src/types/NotificationType';

export const parseOperationName = (query: string): string => {
  const obj = gql(query);
  // @ts-ignore
  return obj.definitions[0].name.value as string;
};

/**
 * Checks if a GraphQL error message indicates an unsupported program and
 * dispatches a user-facing notification identifying the banner.
 */
export function handleUnsupportedProgramError(message: string): void {
  const programName = store.getState().program.selectedProgram;
  if (/unsupported.*program|program.*not supported/i.test(message)) {
    window.dispatchEvent(
      new CustomEvent<NotificationMessageProps>(CategoryManagementEvent.Notification, {
        detail: {
          message: `The program "${programName}" is not supported by the backend. Please contact support.`,
          severity: 'error',
        },
      }),
    );
  }
}

// We use a custom fetcher so that we can manually pass in
// the operation name to the JSON to be consumed by metrics
export function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch('https://api.us-west-2.gamma.categorymanagement.wwgs.amazon.dev/graphql' as string, {
      method: 'POST',
      ...{
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'x-amzn-RequestId': uuidv4(),
          'x-cmt-program-name': store.getState().program.selectedProgram,
        },
      },
      body: JSON.stringify({
        query,
        variables,
        operationName: parseOperationName(query),
      }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      handleUnsupportedProgramError(message);
      throw new Error(message);
    }

    return json.data;
  };
}
